import { Link } from "react-router-dom"
import "./NewsItem.scss";

export const NewsItem = ({ id, data, image, title }) => {
  return <a href={`/newsitem/${id}`} className="news__grid-item nolink" key={id}>
    <div className="d-flex flex-column">
      <div
        style={{ flex: "0 0 10%" }}
        className="p-1 overflow-hidden d-flex justify-content-between"
      >
        <div className="news__item-date">{data}</div>
        <div>Подробнее →</div>
      </div>
      <div
        style={{ flex: "0 0 70%" }}
        className="p-1 overflow-hidden d-flex justify-content-center"
      >
        <div
          style={{
            width: "300px",
            height: "230px",
            backgroundImage: `url(/images/${image})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center center",
            backgroundSize: "contain",
          }}
        ></div>
      </div>
      <div
        style={{ flex: "0 0 20%" }}
        className="p-1 overflow-hidden"
      >
        {title}
      </div>
    </div>
  </a>
} 